import { ModalNamesEnum } from 'app/types/enums/ModalNamesEnum';
import { useModalContext } from '@providers/ModalProvider';
import { usePageContext } from '../../../../../../providers/PageProvider';
import { AdminJobTopActionButton } from '@components/core-ui/form-elements/buttons/Button/variations/AdminJobTopActionButton';
import InlineAttentionIcon from '@components/icons/InlineAttention.svg';

export const JobIssuedButton = () => {
  const { job, manualReload } = usePageContext();

  const { openModal, closeModal } = useModalContext();

  if (!job || job.reportedByAdmin) {
    return null;
  }

  const showBModal = () => {
    openModal(ModalNamesEnum.AdminMarkJobReported, {
      onSuccess: () => {
        closeModal();
        manualReload();
      },
      id: job.id,
    });
  };

  return (
    <AdminJobTopActionButton
      role="button"
      aria-label="Report job"
      onClick={showBModal}
      className="min-w-[120px]"
      title="Report job"
    >
      <InlineAttentionIcon />
      Report job
    </AdminJobTopActionButton>
  );
};
